import { Typography, useTheme } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { Box } from "@mui/system";
import { bindMenu } from "material-ui-popup-state";
import { bindHover, usePopupState } from "material-ui-popup-state/hooks";
import HoverMenu from "material-ui-popup-state/HoverMenu";
import HeaderButton from "./HeaderButton";
import { IPage } from "./types";
import { Link } from "@inertiajs/react";
import { toId } from "@frontend/utils/inputs";

interface IProps {
  page: IPage;
}

const HeaderMenuDesktop = ({ page }: IProps) => {
  const theme = useTheme();

  const popupState = usePopupState({
    variant: "popover",
    popupId: `menu-${toId(page.routes.main)}-popover`,
  });

  if (page.children.length === 0) {
    return <HeaderButton page={page} />;
  } else {
    return (
      <Box>
        <HeaderButton page={page} {...bindHover(popupState)} />
        <HoverMenu
          {...bindMenu(popupState)}
          aria-disabled={page.disabled}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          slotProps={{
            paper: {
              sx: {
                minWidth: "280px",
                overflow: "visible",
                borderTop: "1px solid black",
                borderBottom: `2px solid ${theme.palette.primary.light}`,
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                borderRadius: "0px",

                // Triangle border (outer)
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: -13,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 0,
                  height: 0,
                  borderLeft: "13px solid transparent",
                  borderRight: "13px solid transparent",
                  borderBottom: `13px solid black`,
                  zIndex: 1,
                },
                // Triangle fill (inner)
                "&::after": {
                  content: '""',
                  position: "absolute",
                  top: -12,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 0,
                  height: 0,
                  borderLeft: "12px solid transparent",
                  borderRight: "12px solid transparent",
                  borderBottom: `12px solid white`,
                  zIndex: 2,
                },
              },
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "28px",
              padding: "42px",
            }}
          >
            {page.children.map((child) => (
              <MenuItem
                key={child.title}
                // @ts-expect-error - MUI's MenuItem does not have a 'component' prop although it seems to when the props are checked and it works when we add it.
                component={Link}
                href={child.route}
                disabled={child.disabled}
                disableRipple
                style={{ backgroundColor: "transparent" }}
              >
                <Typography
                  sx={{
                    fontFamily: "Lexend",
                    color: "grey.900",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "18px",
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "underline",
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  {child.title}
                </Typography>
              </MenuItem>
            ))}
          </Box>
        </HoverMenu>
      </Box>
    );
  }
};

HeaderMenuDesktop.displayName = "HeaderMenuDesktop";
export default HeaderMenuDesktop;
